import styled from '@emotion/native'
import { Dimensions } from 'react-native'

export const PHOTO_HEIGHT = Dimensions.get('window').width / 2

export const Image = styled.Image(({}) => ({
  resizeMode: 'cover',
  width: '100%',
  height: '100%',
  borderRadius: 8,
  zIndex: 0,
}))

export const Container = styled.TouchableOpacity(({ theme }) => ({
  width: PHOTO_HEIGHT - theme.sizes.lg + 10,
  height: PHOTO_HEIGHT - theme.sizes.lg + 10,
  overflow: 'hidden',
  position: 'relative',
  margin: theme.sizes.xxxs,
}))

export const FocusView = styled.View(({ theme }) => ({
  position: 'absolute',
  borderWidth: 3,
  borderColor: theme.colors.primary,
  width: '100%',
  height: '100%',
  borderRadius: 8,
}))
